module.exports = __webpack_public_path__ + "static/img/one.c38166e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/one.jpeg
// module id = I8F6
// module chunks = 1